import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class MosfetAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVbrdss = 850;
		this.normRdsOn = 10;
		this.normIdrain = 396;
		this.normQg = 5;

		this.rankVbrdss = 0;
		this.rankRdsOn = 0;
		this.rankIdrain = 0;
		this.rankQg = 0;

		this.weightVbrdss = 0.125;
		this.weightRdsOn = 0.125;
		this.weightIdrain = 0.125;
		this.weightQg = 0.125;

		this.rVbr = 0;
		this.rR = 0;
		this.rI = 0;
		this.rQ = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_rVbr,rVbr,rankVbrdss,' +
					'part_rR,rR,rankRdsOn,' +
					'part_rI,rI,rankIdrain,' +
					'part_rQ,rQ,rankQg,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Breakdown voltage  V(BR)DSS Min (V)-----------------------------------------------------
		const VbrCid = CIDS.BREAKDOWN_VOLTAGE_DSS;
		this.rankVbrdss = this.executorController(VbrCid, product, () => {
			const filterValueLeft = this.usedFilters[VbrCid]
				? this.usedFilters[VbrCid][0]
				: this.filtersState[VbrCid].defaultValue[0];
			const filterValueRight = this.usedFilters[VbrCid]
				? this.usedFilters[VbrCid][1]
				: this.filtersState[VbrCid].defaultValue[1];
			const vbrTarget = Math.abs(filterValueLeft) < Math.abs(filterValueRight) ? filterValueLeft : filterValueRight;
			this.rVbr = Math.abs(product[VbrCid] - vbrTarget);
			return Math.tanh(this.rVbr / this.normVbrdss);
		});

		this.rankDebugLog(product, VbrCid, this.rVbr, this.rankVbrdss);

		// ---------------------------------------------On state resistance  RDS(on) @ VGS = 10 V (mΩ)---------------------------------------------

		[this.rankRdsOn, this.rR] = this.calculateRankSingleSliderLTE(
			CIDS.ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V,
			product,
			this.normRdsOn
		);

		// ---------------------------------------------Drain current  ID Max (A)---------------------------------------------

		const IdCid = CIDS.DRAIN_CURRENT_MAX;
		this.rankIdrain = this.executorController(IdCid, product, () => {
			const filterValueLeft = this.usedFilters[IdCid]
				? this.usedFilters[IdCid][0]
				: this.filtersState[IdCid].defaultValue[0];
			const filterValueRight = this.usedFilters[IdCid]
				? this.usedFilters[IdCid][1]
				: this.filtersState[IdCid].defaultValue[1];
			const idrainTarget = Math.abs(filterValueLeft) < Math.abs(filterValueRight) ? filterValueLeft : filterValueRight;
			this.rI = Math.abs(product[CIDS.DRAIN_CURRENT_MAX] - idrainTarget);
			return Math.tanh(this.rI / this.normIdrain);
		});

		this.rankDebugLog(product, IdCid, this.rI, this.rankIdrain);

		// ---------------------------------------------Gate charge  Qg @ VGS = 10 V (nC)---------------------------------------------

		[this.rankQg, this.rQ] = this.calculateRankSingleSliderLTE(CIDS.GATE_CHARGE_FOR_VGS_10, product, this.normQg);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVbrdss * this.rankVbrdss +
			this.weightIdrain * this.rankIdrain +
			this.weightRdsOn * this.rankRdsOn +
			this.weightQg * this.rankQg;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightVbrdss - this.weightIdrain - this.weightRdsOn - this.weightQg) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
